<template>
  <b-form-group
    :label="label"
    :label-for="id || 'item-' + name"
    :invalid-feedback="form.errors && form.errors.get(name)"
    :description="hint"
  >
    <datepicker
      ref="search"
      v-model="form[name]"
      format="dd.MM.yyyy"
      :bootstrap-styling="true"
      :language="datepickerLang"
      :monday-first="true"
      :full-month-name="true"
      :initial-view="initialView"
      :open-date="openDate"
      :disabled="disabled"
      :typeable="false"
      :input-class="form.errors.has(name) ? 'is-invalid' : ''"
    />
  </b-form-group>
</template>

<script>
import { control } from '~/mixins/control'
import { mapGetters } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import { en, ru } from 'vuejs-datepicker/dist/locale'

const langs = { en, ru }

export default {
  name: 'VDatepicker',

  components: {
    Datepicker
  },
  mixins: [control],

  props: {
    initialView: { type: String, default: null },
    openDate: { type: [String, Date], default: null }
  },

  data: () => ({
    datepickerLang: en
  }),

  computed: {
    ...mapGetters({
      locale: 'lang/locale'
    })
  },

  mounted () {
    this.datepickerLang = langs[this.locale]
  }
}
</script>

<style>
.vdp-datepicker .input-group .form-control[readonly] {
  background: none !important;
}
</style>
